import {
  BotIcon,
  UserRoundCheckIcon,
  Workflow as WorkflowIcon,
} from 'lucide-react';

import type { DraftStepType } from '../builder/types';

/** What the step palette offers, in the order it lists them. */
export const PALETTE_ITEMS: {
  type: DraftStepType;
  label: string;
  description: string;
  Icon: typeof BotIcon;
}[] = [
  {
    type: 'ai_step',
    label: 'AI Step',
    description: 'An agent does the work and decides what happens next.',
    Icon: BotIcon,
  },
  {
    type: 'human_gate',
    label: 'Human Gate',
    description: 'A person reviews and chooses which way the task goes.',
    Icon: UserRoundCheckIcon,
  },
  {
    type: 'linked_workflow',
    label: 'Sub workflow',
    description: 'Creates tasks on another workflow and waits for them.',
    Icon: WorkflowIcon,
  },
];

/**
 * Whether a drop carries one of the kinds the palette offers.
 *
 * Read from the palette's own list, so the canvas accepts exactly what can be
 * dragged: a hand-kept list in the canvas once left Sub workflow out, and it
 * could only be added by clicking.
 */
export function isPaletteStepType(value: string): value is DraftStepType {
  return PALETTE_ITEMS.some((item) => item.type === value);
}
